module.exports = __webpack_public_path__ + "static/media/question.56514da3.svg";